import React from "react";
import { WalletsLinks } from "../WalletsLinks";
import { UserLinks } from "../UserLinks";
import { CountriesBadge } from "./CountriesBadge";
import { formatCurrency } from "../shared/formatCurrency";
import { useTranslation } from "react-i18next";

export const FinancialSummaryColumns = () => {
  const { t } = useTranslation();

  return [
    {
      name: t('firstname'),
      selector: (row) => row.first_name,
      sortable: true,
      wrap: true,
    },
    {
      name: t('lastname'),
      selector: (row) => row.last_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Wallets",
      selector: (row) => row.cc_addresses,
      sortable: false,
      cell: (row) => (
        <WalletsLinks wallets={row.cc_addresses} />
      ),
    },
    {
      name: "Ids",
      selector: (row) => row.user_ids,
      sortable: false,
      cell: (row) => (
        <UserLinks userIds={row.user_ids} />
      ),
    },
    {
      name: t('nacionalidad'),
      selector: (row) => row.country_codes,
      sortable: true,
      center: true,
      cell: (row) => <CountriesBadge countries={row.country_codes} />,
    },
    {
      name: t('withdrawn'),
      selector: (row) => Number(row.total_withdrawals),
      sortable: true,
      right: true,
      cell: (row) => (
        <span className="text-red-600 font-semibold">
          {formatCurrency(row.total_withdrawals)}
        </span>
      ),
    },
    {
      name: t('invested'),
      selector: (row) => Number(row.total_deposits),
      sortable: true,
      right: true,
      cell: (row) => (
        <span className="text-green-600 font-semibold">
          {formatCurrency(row.total_deposits)}
        </span>
      ),
    },
    {
      name: t('total'),
      selector: (row) => Number(row.net_balance),
      sortable: true,
      right: true,
      cell: (row) => (
        <span className={`text-${Number(row.net_balance) > 0 ? 'green' : 'red'}-600 font-semibold`}>
          {formatCurrency(row.net_balance)}
        </span>
      ),
    },
  ];
};
